import { GetServerSidePropsContext } from 'next';
import Image from 'next/image';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { range } from '@effable/misc';

import { MainLayout } from '@/layouts/main-layout';

import { cosmetologyServices } from '@/entities/cosmetology/const';

import { CosmetologyService } from '@/shared/api';
import { Breadcrumbs } from '@/shared/components/breadcrumbs';
import { Button } from '@/shared/components/ui/button';
import { PageSeo } from '@/shared/lib/seo';
import { EnhancedNextPage } from '@/shared/types/enhanced-next-page';

export const getServerSideProps = (ctx: GetServerSidePropsContext) => {
  const serviceId = Number(ctx.query.id as string);

  const service = cosmetologyServices.find((product) => product.id === serviceId) as CosmetologyService;

  if (!service) {
    return {
      notFound: true,
    };
  }

  return {
    props: {},
  };
};

const CosmetologyIdPage: EnhancedNextPage = () => {
  const router = useRouter();

  const serviceId = Number(router.query.id as string);

  const service = cosmetologyServices.find((product) => product.id === serviceId) as CosmetologyService;

  return (
    <>
      <PageSeo title={service.title} description={service.seoDescription} />

      <div className="container py-6">
        <Breadcrumbs paths={[['Косметология', '/cosmetology'], [service.title]]} />
      </div>

      <div className="container space-y-4 pb-6">
        <div className="flex flex-col justify-between space-y-4 md:flex-row md:space-y-0">
          <h1 className="text-4xl">{service.title}</h1>

          <Button size="lg" asChild>
            <a target="_blank" href="https://dikidi.net/951562">
              Онлайн запись
            </a>
          </Button>
        </div>

        <article className="prose max-w-none" dangerouslySetInnerHTML={{ __html: service.description }} />
      </div>
    </>
  );
};

CosmetologyIdPage.Layout = MainLayout;

export default CosmetologyIdPage;
